// A kudos line written on the ward whiteboard: marker handwriting, the words rise one by one and a hand-drawn
// underline sweeps in beneath them. For the dry, warm lines from lib/kudos.ts; never for interface labels.
import type { CSSProperties } from 'react';
import { StaggerWords } from '@/motion/StaggerWords';

const UNDERLINE: Record<'brand' | 'lime' | 'cart', string> = { brand: 'var(--brand)', lime: 'var(--lime)', cart: 'var(--cart)' };

export function Kudos({ text, className = '', delayMs = 0, stepMs = 70, underline = 'brand' }: {
  text: string; className?: string; delayMs?: number; stepMs?: number; underline?: 'brand' | 'lime' | 'cart' | false;
}) {
  const words = text.split(/\s+/).filter(Boolean).length;
  const lineDelay = delayMs + words * stepMs + 80;
  return (
    <span className={`rd-kudos text-[1.375rem] ${className}`}>
      <StaggerWords text={text} delayMs={delayMs} stepMs={stepMs} />
      {underline && (
        <svg className="rd-kudos-line" viewBox="0 0 300 14" preserveAspectRatio="none" aria-hidden="true" style={{ animationDelay: `${lineDelay}ms` } as CSSProperties}>
          <path d="M3 9.5C52 4.5 96 11 148 7.2S246 3.6 297 6.8" fill="none" stroke={UNDERLINE[underline]} strokeWidth={underline === 'lime' ? 7 : 4} strokeLinecap="round" vectorEffect="non-scaling-stroke" opacity={underline === 'lime' ? 0.9 : 1} />
        </svg>
      )}
    </span>
  );
}
